import React, { useRef, useState } from "react";
import Tooltip from "rc-tooltip";
import ReactLoading from "react-loading";
import classnames from "classnames";

import { Button } from "../../components/Button";
import { uploadFile } from "../../utils/upload";

export const HeaderPublishTool = ({
  publishDisabled,
  cover,
  setCover,
  handlePublish,
}) => {
  const [uploading, setUploading] = useState(false);
  const uploadRef = useRef(null);

  //   上传封面
  const handleUploadCover = async (v) => {
    try {
      setUploading(true);
      const data = await uploadFile(v.target.files[0]);

      setCover(data.url);
      uploadRef.current.value = "";
    } catch (e) {
      Notification.newInstance({}, (n) =>
        n.notice({
          content: <span>上传失败请重试</span>,
        })
      );
    } finally {
      setUploading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* <span
        style={{
          color: "#ccc",
        }}
      >
        文章将自动保存至{" "}
        <span
          style={{
            border: "1px solid #EEE",
            padding: "2px 8px",
          }}
        >
          草稿
        </span>
      </span> */}
      <Tooltip
        overlayClassName={classnames("blog-upload-cover-tooltip", {
          uploaded: Boolean(cover),
        })}
        zIndex="10000"
        placement="bottom"
        trigger={["hover"]}
        overlay={
          cover ? (
            <div className="cover-img-wrapper">
              <img height="200px" alt="authing cover" src={cover} />
              <div className="img-mask"></div>
              <div onClick={() => setCover("")} className="delete-wrapper">
                <i className="icon authing-icon authing-delete"></i>
              </div>
            </div>
          ) : (
            <span>添加封面</span>
          )
        }
      >
        {uploading ? (
          <div
            style={{
              margin: "0 24px",
              cursor: "not-allowed",
            }}
          >
            <ReactLoading
              type="spokes"
              color="#215ae5"
              height={20}
              width={20}
            />
          </div>
        ) : (
          <span onClick={() => uploadRef.current.click()}>
            <i
              className="icon authing-icon authing-image"
              style={{
                margin: "0 24px",
                color: "#9BA1A7",
                cursor: "pointer",
              }}
            ></i>
          </span>
        )}
      </Tooltip>
      <Button
        disabled={publishDisabled}
        onClick={handlePublish}
        style={{
          width: 100,
          height: 34,
          display: "inline-block",
          marginRight: 24,
        }}
      >
        发布
      </Button>
      <input
        accept="image/*"
        ref={uploadRef}
        style={{
          display: "none",
        }}
        type="file"
        onChange={handleUploadCover}
      ></input>
    </div>
  );
};
